import { render, staticRenderFns } from "./AdditionalInfoPage.vue?vue&type=template&id=50426378&"
import script from "./AdditionalInfoPage.vue?vue&type=script&lang=ts&"
export * from "./AdditionalInfoPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports